import { createBrowserRouter } from "react-router-dom";
import { Base } from "./layouts/Base";
import { Landing } from "./pages/Landing";
import { Lens } from "./pages/Lens";
import { Experience } from "./pages/Experience";
import { Project } from "./pages/Project";
import { Print } from "./pages/Print";
import { Graph } from "./pages/Graph";
import { DesignSystem } from "./pages/DesignSystem";
import { AppAbout } from "./pages/AppAbout";
import { Architecture } from "./pages/Architecture";
import { ContentStudio } from "./pages/ContentStudio";
import { ConfigPage } from "./components/ConfigManagement";
import { DocsPage } from "./components/DocsDialog";
import { ModelSettings } from "./pages/ModelSettings";
import { TrackerAdmin } from "./pages/TrackerAdmin";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Base />,
    children: [
      { index: true, element: <Landing /> },
      { path: "by/:lens", element: <Lens /> },
      { path: "experience/:id", element: <Experience /> },
      { path: "project/:id", element: <Project /> },
      // legacy URL — the Graph page now redirects to /?cview=graph
      { path: "graph", element: <Graph /> },
      { path: "print", element: <Print /> },
      { path: "app", element: <AppAbout /> },
      { path: "design-system", element: <DesignSystem /> },
      { path: "architecture", element: <Architecture /> },
      { path: "admin/content", element: <ContentStudio /> },
      { path: "admin/settings", element: <ConfigPage section="settings" /> },
      { path: "admin/profile", element: <ConfigPage section="profile" /> },
      { path: "admin/docs", element: <DocsPage /> },
      { path: "admin/models", element: <ModelSettings /> },
      { path: "admin/tracker", element: <TrackerAdmin /> },
      { path: "*", element: <Landing /> },
    ],
  },
]);
